import { useTranslation } from 'react-i18next';
import { Card } from '../ui/Card';
import type { RiskItem } from '../../types/api.js';

interface RiskAssessmentProps {
  /** リスク項目リスト */
  risks: RiskItem[];
}

/** @graph-connects none */
const RISK_STYLES: Record<string, { className: string; icon: string }> = {
  warning: { className: 'risk-warning', icon: '⚠' },
  info: { className: 'risk-info', icon: 'ℹ' },
  positive: { className: 'risk-positive', icon: '✓' },
};

/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business リスクアセスメント表示。warning/info/positiveレベルごとにスタイル分けしたリスク項目リスト
 * @graph-connects none
 */
export function RiskAssessment({ risks }: RiskAssessmentProps) {
  const { t } = useTranslation();

  if (risks.length === 0) return null;

  return (
    <Card variant="glass">
      <h3 className="text-sm font-semibold text-[var(--color-text-primary)] mb-3">
        {t('scoring.riskTitle')}
      </h3>
      <div className="space-y-2">
        {risks.map((risk, i) => {
          const style = RISK_STYLES[risk.level] ?? RISK_STYLES.info;
          return (
            <div key={i} className={style.className}>
              <span className="mr-2">{style.icon}</span>
              <span className="text-sm text-[var(--color-text-primary)]">{risk.text}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
